module.exports = __webpack_public_path__ + "packs/media/images/errors-images/404-error-fba57f1902230aa354fc268445468e97.png";